'use client';

import { CustomError } from '@core/utils';
import { create } from 'zustand';

import { STORAGE_KEY, type STORAGE_TYPE } from '@/constants/storage-key';

interface HistoryStore {
  historyIndex: number;
  setHistoryIndex: (historyIndex: number) => void;

  customHistory: Map<number, string>;
  setCustomHistory: (customHistory: Map<number, string>) => void;
}

export const useHistoryStore = create<HistoryStore>((set) => {
  let historyIndex = -1;
  const customHistory = new Map<number, string>();

  if (typeof window !== 'undefined') {
    const sessionExpire = sessionStorage.getItem(STORAGE_KEY.HISTORY_EXPIRE);

    try {
      if (sessionExpire ? Number(sessionExpire) < Date.now() : true)
        throw new CustomError();

      const sessionHistory = sessionStorage.getItem(STORAGE_KEY.HISTORY);
      const sessionHistoryIndex = sessionStorage.getItem(
        STORAGE_KEY.HISTORY_INDEX,
      );

      if (!sessionHistory || !sessionHistoryIndex) throw new CustomError();

      historyIndex = Number(sessionHistoryIndex);

      const history: STORAGE_TYPE.HISTORY = JSON.parse(sessionHistory);

      history.forEach(([index, path]) => {
        customHistory.set(index, path);
      });
    } catch {
      customHistory.clear();
    } finally {
      sessionStorage.removeItem(STORAGE_KEY.HISTORY_EXPIRE);
      sessionStorage.removeItem(STORAGE_KEY.HISTORY);
      sessionStorage.removeItem(STORAGE_KEY.HISTORY_INDEX);
    }
  }

  return {
    historyIndex,
    customHistory,
    setHistoryIndex: (historyIndex) => {
      sessionStorage.setItem(
        STORAGE_KEY.HISTORY_INDEX,
        historyIndex.toString(),
      );

      return set({
        historyIndex,
      });
    },
    setCustomHistory: (customHistory) => {
      sessionStorage.setItem(
        STORAGE_KEY.HISTORY,
        JSON.stringify(Array.from(customHistory.entries())),
      );

      return set({ customHistory });
    },
  };
});
